import { Component, OnInit, ViewChild, AfterViewInit } from '@angular/core';
import { WordpressService } from '../wordpress.service';
import { OmekaClassicService } from '../omeka-classic.service';
import { GeojsonService } from '../geojson.service';
import { Observable } from 'rxjs';
import { Item } from '../item';
import {MatPaginator} from '@angular/material/paginator';
import {MatTableDataSource} from '@angular/material/table';
// import {MatTableDataSource} from '@angular/material';


@Component({
  selector: 'app-grid',
  templateUrl: './grid.component.html',
  styleUrls: ['./grid.component.css']
})
export class GridComponent implements OnInit {

  /* DEBEMOS CREAR UN PROXY CON NGINX PARA HACER LECTURAS Y EVITAR CORS ..*/
  /* DEBEMOS CREAR UN ITEM TYPE BASICO PARA TODOS Y ASÍ CARGAR LOS DATOS DE MANERA MÁS CONTROLADA SEGUN EL CONTENT MANAGER */


  // @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatPaginator, { static: false }) paginator: MatPaginator;

  search:string = ""
  items:Item[]=[];
  feeds = [
    {type:"wordpress", search:"", categories:"https://www.gransassolagaich.it/wp-json/wp/v2/categories", url:"https://www.gransassolagaich.it/wp-json/wp/v2/posts?_embed",slug:'bambun',name:"Bambun",status:-1,per_page:10,page:1,total_pages:0},
    {type:"wordpress", search:"", categories:"https://www.archive.binauralmedia.org/wp-json/wp/v2/categories", url:"https://www.archive.binauralmedia.org/wp-json/wp/v2/avada_portfolio?_embed",slug:'binauralnodar',name:"Binaural",status:-1,per_page:10,page:1,total_pages:0},
    // {type:"wordpress", url:"http://backend.industriapaisaia.eus/wp-json/wp/v2/posts?_embed",name:"Local",status:0},
    {type:"geojson", search:"", categories:"",url:"http://www.soinumapa.net/geojson/",name:"Audiolab",slug:"soinumapa",status:0,per_page:20,page:1,total_pages:0},
    {type:"omeka", search:"", categories:"http://oralitat", url:"https://tramontana.audio-lab.org/oralitatdegasconha/",name:"Oralitat de Gasconha",slug:'oralitatgasconha',status:-1,per_page:10,page:1,total_pages:0},
  ]
  terms:any[]=[];
  countItems:number = 0;

  displayedColumns: string[] = ['title','description'];
  dataSource = new MatTableDataSource<Item>(this.items);

  constructor(
    private wService:WordpressService,
    private oService:OmekaClassicService,
    private gService:GeojsonService,
  ) { }

  AfterViewInit() {

  }

  ngOnInit() {
    //this.posts$ = this.wService.getPosts()
    // .subscribe(
    //   (data)=>{console.log(data)},
    //   (error)=>{console.error(error)}
    // )
    this.loadFeeds();
    this.loadCategories();
    this.dataSource.paginator = this.paginator;
  }

  loadCategories() {
    this.feeds.map(
      (feed) => {
        /* wordpress */
        if (feed.type==="wordpress") {
          this.wService.getCategories(feed.categories)
          .subscribe(
            res => {
              res.body.map(
                (cat)=> this.terms.push({name:cat.name,id:feed.slug+":"+cat.id})
              )
              this.terms.sort( (a,b) => {
                return a.name.toUpperCase().localeCompare(b.name.toUpperCase())
              });
            }
          )
        }
        /* Omeka */
        else if (feed.type==="omeka") {
          this.oService.getTags(feed.url)
          .subscribe(
            res => {
              res.body.map(
                (tag) => this.terms.push({name:tag.name,id:feed.slug+":"+tag.id})
              )
              this.terms.sort( (a,b) => {
                return a.name.toUpperCase().localeCompare(b.name.toUpperCase())
              });
            }
          )
        }
      }
    )
  }

  updateSearch() {
    this.feeds.map(
      (feed) => {
        feed.search = this.search
        feed.total_pages = 0
      }
    )
    this.loadFeeds()
  }

  showMore() {
    // nextpage
    this.feeds.map(
      (feed) => {
        if (feed.status==0) return // is loading
        if (feed.page<=feed.total_pages) {
          feed.page++;
          this.loadFeed(feed)
        }
      }

    )
  }

  loadFeeds(){
    this.items = []
    this.countItems = 0
    this.feeds.map(
      (feed) => { this.loadFeed(feed) }
    );
  }

  loadFeed(feed) {
    feed.status=0;
    if (feed.type==="wordpress") {
      this.wService.getPosts(feed)
        .subscribe(
          (res)=> {
            let numItems = +res.headers.get('X-WP-Total')
            let totalPages = res.headers.get('X-WP-TotalPages')
            if (feed.total_pages==0) {
              feed.total_pages = +totalPages
              this.countItems+=numItems
            }
            feed.status = 1
            res.body.map(
              (i) => {
                let thumbnail = ""
                if (i['_embedded']['wp:featuredmedia']) thumbnail = i['_embedded']['wp:featuredmedia'][0]['media_details']['sizes']['thumbnail']['source_url']
                let item:Item = {
                  id:feed.slug+"_"+i['id'],
                  repository:feed.name,
                  repositorySlug:feed.slug,
                  title:i.title.rendered,
                  description:i.excerpt.rendered,
                  link:i.link,
                  thumbnail:thumbnail
                }
                this.items.push(item)
              }
            );
            //this.items.sort( (a,b) => a.title.localeCompare(b.title));
          }
        )
    }
    else if (feed.type==="geojson") {
      feed.status = 0
      let features = this.gService.getItems(feed)
      if (feed.total_pages==0) {
        feed.total_pages = this.gService.getTotalPages()
        let numItems = this.gService.getCount()
      this.countItems+=numItems
      }
      features.map(
        (feature) => {
          let i = feature.properties
          if (i) {
            let item:Item = {
              id:feed.slug+"_"+i.id,
              repository:feed.name,
              repositorySlug:feed.slug,
              title:i.title,
              description:i.content.replace(/(<([^>]+)>)/ig,""),
              link:i.href,
              thumbnail:'',
            }
            this.items.push(item)
          }
        }
      )
      feed.status = 1
    }
    /** omeka **/
    else if (feed.type==="omeka") {
      feed.status = 0
      this.oService.getItems(feed)
        .subscribe(
          (res)=> {
            let numItems = +res.headers.get('Omeka-Total-Results')
            let pages = numItems/feed.per_page
            if (pages%1!=0) pages=Math.floor(pages)+1;
            if (feed.total_pages==0) {
              feed.total_pages = pages
              this.countItems+=numItems
            }
            feed.status = 1
            res.body.map(
              (i)=> {
                let subjects = this.getOmekaSubjects(i);
                let item:Item = {
                  id:feed.slug+"_"+i['id'],
                  repository:feed.name,
                  repositorySlug:feed.slug,
                  title:i['element_texts'][0]['text'],
                  description:subjects.toString(),
                  link:"http://oralitatdegasconha.net/culturaviva/items/show/"+i['id'],
                  thumbnail:'http://oralitatdegasconha.net/culturaviva/files/theme_uploads/577dc3ddb797af39c4d39d324893d767.jpg'
                }
                this.items.push(item)
              }
            )
          }
        )
    }
  }

  getOmekaSubjects(i:any) {
    let subjects = []
    i['element_texts'].map(
      (e) => {
        if (e['element']['name'] === "Subject")  subjects.push(e['text'])
      }
    )
    return subjects
  }

  filterByTerm(term:number) {
    this.items = this.items.filter( (item)=> {if (item['_embedded']['wp:term']) {item['_embedded']['wp:term'][0].map( (cat)=> {return cat.id==term} )} })
  }

}
